import { Component, ElementRef, HostListener, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ArticlesService } from '../../../services/articles.service';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { CommonModule, IMAGE_CONFIG } from '@angular/common';
import { AuthService } from '../../../services/auth.service';
import { Article } from '../../../interfaces/article';
import { ArticleFile } from '../../../interfaces/image';
import { Connect } from '../../../classes/connect';
import { ApiResponse } from '../../../interfaces/api-response';
import { MatTooltip } from '@angular/material/tooltip';
import { MatDialog } from '@angular/material/dialog';
import { ModalViewerComponent } from '../components/modal-viewer/modal-viewer.component'
import { PopupDialogService } from '../../../services/popup-dialog.service';
import { ConnectServerService } from '../../../services/connect-server.service';
import { ImageViewerComponent } from '../components/image-viewer/image-viewer.component';
import { PdfDisplayComponent } from '../components/pdf-display/pdf-display.component';
import { ImgDisplayComponent } from '../components/img-display/img-display.component';
import { PdfThumbnailService } from '../../../services/pdf-thumbnail.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-article-historical',
    imports: [
        CommonModule,
        RouterModule,
    ],
    templateUrl: './article-historical.component.html',
    styleUrl: './article-historical.component.scss'
})
export class ArticleHistoricalComponent {
  @ViewChildren('thumb') private thumbs?: QueryList<ElementRef<HTMLButtonElement>>;

  urlServerLaraApiMultimedia = Connect.urlServerLaraApiMultimedia;
  files: ArticleFile[] = [];
  filesLoaded = false;
  thumbnails: { [key: string]: string } = {}; // Memorizza le thumbnail dei PDF

  isLogged: boolean = false;

  showModal: boolean = false;
  modalImageUrl: string = '';
  articleData: { dimension: string, imgFormat: string, weigth: number, id: number } = { dimension: '', imgFormat: '', weigth: 0, id: 0 };
  id: number = 0;
  article!: Article | null;
  currentImg: number = 0;

  constructor(private route: ActivatedRoute, public articlesService: ArticlesService, private router: Router,
    private viewportRuler: ViewportRuler, public authService: AuthService,
    public dialog: MatDialog, public popupDialogService: PopupDialogService,
    private connectServerService: ConnectServerService, private pdfThumbnailService: PdfThumbnailService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.checkWindowSize();
    this.initialize();
    this.isLogged = this.authService.isLoggedIn();
  }

  async generatePdfThumbnails(): Promise<void> {
    for (const file of this.files) {
      if (file.ext === 'pdf') {
        const thumbnail = await this.pdfThumbnailService.generateThumbnail(this.urlServerLaraApiMultimedia + file.src);
        this.thumbnails[file.src] = thumbnail;
      }
    }
  }

  getSafeUrl(videoId: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(`https://www.youtube.com/embed/${videoId}`);
  }

  openFullscreenModal(articleFile: ArticleFile): void {

    const id = articleFile.id;
    if (id > 0) {
      if (articleFile.ext == "pdf") {
        this.dialog.open(PdfDisplayComponent, {
          data: { article: articleFile },
          panelClass: 'fullscreen-modal',
          width: '90vh',
          height: '90vh',
          maxHeight: '90vh',
          maxWidth: '95vw',
          minWidth: '250px',
          position: {
            top: '70px',
          },
          // autoFocus: false
        });
      }
      else {
        this.dialog.open(ImgDisplayComponent, {
          data: { article: articleFile },
        });
      }
    }
  }

  initialize() {
    this.route.params.subscribe(
      (params) => {
        //console.error('params: ', params['name'])
        this.id = params['id'];
        this.currentImg = 0;
        this.files = [];
        this.filesLoaded = false;
        this.articlesService.getArticleFromServer(this.id).
          subscribe((val: ApiResponse<{ article: Article }>) => {
            this.article = val.data.article;
          });
        //this.articleData = this.articlesService.getArticleData(this.id);
        this.articlesService.getFilesServer(this.id).
          subscribe((val: ApiResponse<{ listFiles: ArticleFile[] }>) => {
            this.files = val.data.listFiles ?? [];
            this.filesLoaded = true;
            this.generatePdfThumbnails();

            this.files.forEach(file => {
              if (file.ext == 'youtube') {
                file.sanitized_url = this.getSafeUrl(file.src);
              }
            });
          });
      }
    );
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkWindowSize();
  }

  navigate(id: number) {
    this.router.navigate(['/archivioStorico/scheda/imageviewer', id])
  }

  // getBlurredImage(): string {
  //   return this.article?.src[this.currentImg]!;
  // }

  checkWindowSize() {
    const screenWidth = this.viewportRuler.getViewportSize().width;
    if (screenWidth <= 768) {
      this.showModal = false;
    }
    else {
      this.showModal = true;
    }
  }

  setModalContent(imageUrl: string) {
    this.modalImageUrl = imageUrl;
  }

  nextImg() {
    //if(this.article?.src.length! > this.currentImg + 1) {
    if (this.files.length > this.currentImg + 1) {
      this.currentImg += 1;
    }
    //else if(this.article?.src.length === this.currentImg + 1)
    else if (this.files.length === this.currentImg + 1) {
      this.currentImg = 0;
    }
    this.revealThumb();
    //console.log("current img:", this.currentImg);
  }

  prevImg() {
    if (this.currentImg > 0) {
      this.currentImg -= 1;
    }
    else if (this.currentImg === 0) {
      this.currentImg = this.files.length - 1;
    }
    this.revealThumb();
    //console.log("current img:", this.currentImg);
  }

  goToImg(i: number) {
    this.currentImg = i;
    this.revealThumb();
  }

  private revealThumb(): void {
    queueMicrotask(() => {
      this.thumbs?.get(this.currentImg)?.nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    });
  }

  cityLabel(city: Article['city'] | null | undefined): string {
    if (!city) {
      return '';
    }
    return typeof city === 'string' ? city : city.name;
  }

  hasPlacement(article: Article): boolean {
    return !!(article.floor || article.room || article.rack || article.case || article.shelf);
  }

  // goNext() {
  //   this.router.navigate(['/archivio/scheda', this.articlesService.nextId]).then(() => this.initialize());
  // }

  // goPrev() {
  //   this.router.navigate(['/archivio/scheda', this.articlesService.prevId]).then(() => this.initialize());
  // }

  goBack() {
    window.history.back();
  }

  deleteArticle(id: number) {
    const obj_request: ApiResponse<any> = {
      code: 244,
      data: {},
      title: 'Info',
      message: 'Sei sicuro di voler cancellare l\'articolo?',
      obj_dialog: {
        disableClose: 0,
        obj_buttonAction:
        {
          action: 1,
          action_type: 2,
          label: 'Cancella',
          run_function: () => this.deleteArticleFromServer(id)
        }
      }
    }
    this.popupDialogService.popupDialog(obj_request);
  }

  private deleteArticleFromServer(id: number) {
    this.connectServerService.postRequest<ApiResponse<any>>('articleObsolete', { idarticle: id })
      .subscribe((val: any) => {
        this.popupDialogService.popupDialog(val);
        this.router.navigate(["archivioStorico"]);
      })
  }

  // getIdNext() {
  //   if (this.hasNextImage()) {
  //     return this.article?.id! + 1
  //   }
  //   else return null;
  // }

  // getIdPrev() {
  //   if (this.hasPreviousImage()) {
  //     return this.article?.id! - 1
  //   }
  //   else return null;
  // }

  // hasPreviousImage(): boolean {
  //   return (this.article?.id! > 1);
  // }

  // hasNextImage(): boolean {
  //   return (this.article?.id != 0 && this.articlesService.total() > this.article?.id!);
  // }

}
